import { FC, PropsWithChildren } from "react";
import styled, { keyframes } from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { deepPurpleMui } from "@ryde/theme";

interface ISpinner extends PropsWithChildren {
  loading?: boolean;
}

const blinker = keyframes`
  30% {
    opacity: 30%;
  }
  50% {
    opacity: 60%;
  }
  80% {
    opacity: 80%;
  }
`;

const LayoutRightLoaderTextStyled = styled.p.attrs<IStyledAttributes>({
  "data-e2e": "layout-right-loader-text",
})<ISpinner>`
  color: ${deepPurpleMui._700};
  font-weight: bold;
  animation: ${blinker} 1s step-start infinite;
  width: 100%;
  text-align: center;
  padding-top: 30px;
`;

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const LayoutRightLoadingSpinnerStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "layout-right-loading-spinner",
})<ISpinner>`
  border: 5px solid ${deepPurpleMui.A400};
  border-radius: 50%;
  border-top-color: white;
  opacity: 1;
  position: absolute;
  inset-inline-start: 25%;
  inset-inline-end: 25%;
  top: 25%;
  bottom: 25%;
  margin: auto;
  width: 86px;
  height: 86px;
  transition: opacity 200ms;
  animation: ${rotate} 1s linear infinite;
`;

export const LayoutRightLoaderSlotStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "layout-right-loader-slot",
})`
  position: relative;
  min-height: 240px;
  width: 100%;
`;

export const LayoutRightLoader: FC<ISpinner> = ({ children }) => {
  return (
    <>
      <LayoutRightLoadingSpinnerStyled />
      <LayoutRightLoaderTextStyled>{children}</LayoutRightLoaderTextStyled>
    </>
  );
};
